import React, { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faPlus } from '@fortawesome/free-solid-svg-icons';
import AppContext from 'context/Context';
import ManageShortcutsModal from './ManageShortcutsModal';

const TicketQuickCommands = ({
  onSelectCommand,
  commands = [],
  onReload,
  clientOpenTickets = []
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasOpenTickets = clientOpenTickets && clientOpenTickets.length > 0;
  const firstTicket = hasOpenTickets ? clientOpenTickets[0] : null;
  const firstTicketId = firstTicket?.idTicket || firstTicket?.id;
  const firstSubject = firstTicket?.vAsunto ? ` respecto a "${firstTicket.vAsunto}"` : '';

  const mergePromptMessage = clientOpenTickets.length === 1
    ? `Hola, notamos que ya cuentas con el ticket #${firstTicketId} abierto en atención${firstSubject}. ¿Deseas que combinemos esta conversación con tu ticket existente para darte seguimiento conjunto en un solo reporte?`
    : `Hola, identificamos que cuentas con tickets abiertos en atención. ¿Deseas que unifiquemos esta conversación con tu ticket previo para darte seguimiento continuo en un solo reporte?`;

  const mergePillLabel = '/combinar';
  const mergePillTitle = firstTicketId
    ? `Preguntar al cliente si desea combinar con Ticket #${firstTicketId}`
    : 'Preguntar al cliente si desea combinar tickets';

  return (
    <div
      className="px-3 py-1 border-top d-flex align-items-center gap-2 overflow-x-auto"
      style={{
        backgroundColor: isDark ? '#121e2d' : '#f8fafc',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      <small
        className="d-flex align-items-center gap-1"
        style={{ fontSize: '0.72rem', whiteSpace: 'nowrap', color: isDark ? '#94a3b8' : '#64748b' }}
      >
        <FontAwesomeIcon icon={faBolt} style={{ fontSize: '0.68rem', color: '#059669' }} />
        Atajos:
      </small>

      {/* Atajo dinámico programado: solo aparece cuando el cliente tiene tickets abiertos */}
      {hasOpenTickets && (
        <button
          type="button"
          title={mergePillTitle}
          onClick={() => onSelectCommand(mergePromptMessage, false)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onSelectCommand(mergePromptMessage, true);
            }
          }}
          className="se-shortcut-pill se-shortcut-pill-merge shadow-none"
        >
          {mergePillLabel}
        </button>
      )}

      {/* Botones de atajos dinámicos */}
      {commands.map((cmd, idx) => {
        const label = cmd.vComando || cmd.label || '';
        const text = cmd.vTexto || cmd.text || '';
        const title = cmd.vTitulo || cmd.title || text;
        return (
          <button
            key={idx}
            type="button"
            title={title}
            onClick={() => onSelectCommand(text, false)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onSelectCommand(text, true);
              }
            }}
            className="se-shortcut-pill shadow-none"
          >
            {label}
          </button>
        );
      })}

      {/* Botón para administrar / crear atajos */}
      <button
        type="button"
        title="Administrar o crear atajos"
        onClick={() => setIsModalOpen(true)}
        className="se-shortcut-pill-add shadow-none"
      >
        <FontAwesomeIcon icon={faPlus} style={{ fontSize: '0.62rem' }} />
        <span>Atajo</span>
      </button>

      {isModalOpen && (
        <ManageShortcutsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          commands={commands}
          onReload={onReload}
        />
      )}
    </div>
  );
};

export default TicketQuickCommands;


